import { TimesheetEstimatedTimeFragment } from 'generated/resources/graphql'

import AttendanceMinutesCalculationUtils from './AttendanceMinutesCalculationUtils'
import { AggregatedWorkedTimeBlocks } from './AttendanceWorkedTimeUtils'

export const calculateTimesheetBalanceBreakdown = ({
  aggregatedWorkedTime,
  estimatedTimes,
  extraHoursMinutes = 0,
}: {
  aggregatedWorkedTime?: AggregatedWorkedTimeBlocks | null
  estimatedTimes: TimesheetEstimatedTimeFragment[]
  extraHoursMinutes?: number
}) => {
  const today = new Date()

  const workedMinutes = aggregatedWorkedTime?.minutes ?? 0
  const paidBreaksMinutes = aggregatedWorkedTime?.paidBreaksMinutes ?? 0
  const paidAbsencesMinutes = aggregatedWorkedTime?.paidAbsencesMinutes ?? 0
  const effectiveWorkedMinutes = aggregatedWorkedTime?.effectiveWorkedMinutes ?? 0

  const estimatedRecords = estimatedTimes.filter((estimatedTime) => {
    const estimatedDate = new Date(estimatedTime.date)
    return estimatedDate <= today
  })
  const estimatedMinutes = estimatedRecords.reduce(
    (acc, estimatedTime) => acc + (estimatedTime.minutes ?? 0),
    0
  )

  const contractMinutes = estimatedRecords.reduce(
    (acc, estimatedTime) => acc + (estimatedTime.contractMinutes ?? 0),
    0
  )

  const regularMinutes = aggregatedWorkedTime?.regularMinutes ?? 0
  const workedExtraMinutes = aggregatedWorkedTime?.extraTimeMinutes ?? 0
  const workedTimeBlocks = aggregatedWorkedTime?.workedTimeBlocks ?? []
  const approvedExtraTimeMinutes = aggregatedWorkedTime?.approvedExtraTimeMinutes ?? 0

  const balancedRegularMinutes = AttendanceMinutesCalculationUtils.calculateBalancedRegularMinutes({
    regularMinutes,
    approvedWorkedExtraMinutes: approvedExtraTimeMinutes,
    extraHoursMinutesFromBalance: extraHoursMinutes,
  })

  const trackedMinutes = aggregatedWorkedTime?.trackedMinutes ?? 0

  const unapprovedOvertimeMinutes = workedTimeBlocks
    .filter((block) => block.timeType === 'overtime' && !block.approved)
    .reduce((sum, block) => sum + (block.minutes || 0), 0)

  const trackedMinutesDelta = aggregatedWorkedTime?.trackedMinutesDelta ?? 0

  return {
    workedMinutes,
    paidBreaksMinutes,
    paidAbsencesMinutes,
    effectiveWorkedMinutes,
    estimatedMinutes,
    contractMinutes,
    extraTimeMinutes: extraHoursMinutes,
    workedExtraMinutes,
    regularMinutes,
    balancedRegularMinutes,
    trackedMinutes,
    unapprovedOvertimeMinutes,
    trackedMinutesDelta,
  }
}
